import { render, staticRenderFns } from "./LinkToActionplan.vue?vue&type=template&id=40ee01e4"
import script from "./LinkToActionplan.vue?vue&type=script&lang=js"
export * from "./LinkToActionplan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports